import { ActionTree } from 'vuex'
import { RootState } from '../../types';
import { SubscriptionPreferenceState } from './types';

export const subscriptionPreferenceActions: ActionTree<SubscriptionPreferenceState, RootState> = {
  async FETCH_SUBSCRIPTION_PREFERENCE({ commit }: { commit: any }, messageListOid: number | string) {
    try {
      const { data } = await this.$axios.get(`/subscription-preferences`, {
        params: {
          messageListOid: messageListOid,
        }
      });
      
      if (typeof data === 'object' && data !== null) {
        commit('SET_SUBSCRIPTION_PREFERENCE', data);
      }

      return true;
    } catch (error) {
      console.error(error);
      return true;
    }
  },
};